import TimerDisplayV2 from "components/CountdownV2/TimerDisplayV2";
import { useWebStoreContext } from "contexts";
import { useAppDispatch, useAppSelector } from "hooks";
import moment from "moment";
import { useEffect } from "react";
import { onSetTimers, selectBundleUpState } from "redux/slices/bundle-up";
import { Container } from "./styles";

interface DataOverlayProps {
	cooldownMinutes: number;
}

export const DataOverlay = ({ cooldownMinutes }: DataOverlayProps) => {
	const dispatch = useAppDispatch();
	const { nowTime } = useWebStoreContext();
	const { cooldownTime } = useAppSelector(selectBundleUpState);

	useEffect(() => {
		if (cooldownTime && nowTime && nowTime < moment(cooldownTime)) {
			return;
		}
		dispatch(
			onSetTimers({
				cooldownTime: moment(nowTime)
					.add(cooldownMinutes, "minutes")
					.toISOString()
			})
		);
	}, [cooldownTime]);

	return (
		<Container>
			<span>
				Cooldown:
				{cooldownTime && (
					<TimerDisplayV2
						endTime={cooldownTime}
						startTime={nowTime}
						onEnd={() => {}}
					/>
				)}
			</span>
		</Container>
	);
};
